import React from "react";
import { indianStates } from "../data/OnboardingData";
import { LocationIcon, ArrowRightIcon, ArrowLeftIcon } from "../icons/OnboardingIcons";

const BusinessInfoStep = ({ formData, updateFormData, onNext, onBack }) => {

  const canContinue =
    formData.gymName &&
    formData.address &&
    formData.state &&
    formData.city &&
    formData.pincode;

  return (
    <div className="v2-business-info-step">
      <div className="v2-step-header">
        <div className="v2-step-icon v2-step-icon--red">
          <LocationIcon />
        </div>
        <h2 className="v2-step-title">Business Information</h2>
      </div>

      <p className="v2-step-description">
        Enter the gym's business and registration details
      </p>

      {/* Gym Name and Registration */}
      <div className="v2-form-row">
        <div className="v2-form-group">
          <label className="v2-form-label">
            Gym Name <span className="v2-form-required">*</span>
          </label>
          <input
            type="text"
            className="v2-form-input"
            placeholder="Enter gym name"
            value={formData.gymName}
            onChange={(e) => updateFormData("gymName", e.target.value)}
          />
        </div>

        <div className="v2-form-group">
          <label className="v2-form-label">Business Registration Number</label>
          <input
            type="text"
            className="v2-form-input"
            placeholder="Enter registration number"
            value={formData.registrationNumber}
            onChange={(e) => updateFormData("registrationNumber", e.target.value)}
          />
        </div>

        {/* GST Number */}
        <div className="v2-form-group">
          <label className="v2-form-label">GST Number</label>
          <input
            type="text"
            className="v2-form-input"
            placeholder="Enter GST number"
            value={formData.gstNumber}
            onChange={(e) => updateFormData("gstNumber", e.target.value)}
          />
        </div>
      </div>

      {/* Address */}
      <div className="v2-form-group">
        <label className="v2-form-label">
          Address <span className="v2-form-required">*</span>
        </label>
        <textarea
          className="v2-form-textarea"
          placeholder="Enter full address"
          rows="4"
          value={formData.address}
          onChange={(e) => updateFormData("address", e.target.value)}
        />
      </div>

      {/* State, City, Pincode */}
      <div className="v2-form-row v2-form-row--three">
        <div className="v2-form-group">
          <label className="v2-form-label">
            State <span className="v2-form-required">*</span>
          </label>
          <select
            className="v2-form-select"
            value={formData.state}
            onChange={(e) => updateFormData("state", e.target.value)}
          >
            <option value="">Select state</option>
            {indianStates.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>
        </div>

        <div className="v2-form-group">
          <label className="v2-form-label">
            City <span className="v2-form-required">*</span>
          </label>
          <input
            type="text"
            className="v2-form-input"
            placeholder="Enter city"
            value={formData.city}
            onChange={(e) => updateFormData("city", e.target.value)}
          />
        </div>

        <div className="v2-form-group">
          <label className="v2-form-label">
            Pincode <span className="v2-form-required">*</span>
          </label>
          <input
            type="text"
            className="v2-form-input"
            placeholder="Enter pincode"
            value={formData.pincode}
            onChange={(e) => updateFormData("pincode", e.target.value)}
            maxLength="6"
          />
        </div>
      </div>

      {/* Actions */}
      <div className="v2-step-actions">
        <button className="v2-btn v2-btn--back" onClick={onBack}>
          <ArrowLeftIcon />
          Back
        </button>
        <button
          className="v2-btn v2-btn--primary"
          onClick={onNext}
          disabled={!canContinue}
        >
          Continue to Owner Details
          <ArrowRightIcon />
        </button>
      </div>
    </div>
  );
};

export default BusinessInfoStep;
